var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',[(!_vm.$store.state.app.waitingForConnection)?_c('router-view'):_c('offline')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }